import React from 'react';
import { object, string, ref } from 'yup';
import { Formik, Form } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';

import { useHttpStatus } from '~/commons/hooks';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import useQuery from '../../../commons/hooks/useQuery';

const t = {
  en: {
    success: {
      title: 'Password reset successful',
      message: 'Your password has been changed successfully.',
      negative: 'Back to CMS home page',
    },
    title: 'Password reset',
    newPwd: 'New password',
    newPwdPh: 'Password must contain 8-20 characters, one uppercase, one lowercase, one number',
    confirmPwd: 'Confirm new password',
    resetPwd: 'Reset password',
    errMsg: 'Both passwords need to be the same.',
  },
  'zh-Hant': {
    success: {
      title: '密碼重置成功',
      message: '你已經成功更改密碼。',
      negative: '返回CMS主頁',
    },
    title: '更改密碼',
    newPwd: '新密碼',
    newPwdPh: '密碼必須包含8-20個字元，一個大寫字母，一個小寫字母，一個數字',
    confirmPwd: '確認新密碼',
    resetPwd: '重設密碼',
    errMsg: '兩個密碼需要相同',
  },
};

const FormPwdReset = ({ resetKey }) => {
  const [res, req] = useHttpStatus();
  const { lg = 'en' } = useQuery();

  const schema = object().shape({
    password: string()
      .min(7, t[lg].newPwdPh)
      .required(t[lg].newPwdPh)
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=[a-zA-Z0-9!@#$^*]*$)(?=.{8,20}$)/,
        'Password must contain 8-20 characters, one uppercase, one lowercase, one number',
      ),
    passwordConfirm: string()
      .oneOf(
        [ref('password')],
        t[lg].errMsg,
      )
      .required(),
  });
  const defaults = {
    password: '',
    passwordConfirm: '',
  };

  return (
    <>
      {res.status === 'success' ? (
        <div>
          <h2>
            <FA icon={faCheckCircle} />
            &nbsp;
            {t[lg].success.title}
          </h2>
          <p>
            {t[lg].success.message}
            <br />
            <a href="/">
              {t[lg].success.negative}
            </a>
          </p>
        </div>
      ) : (
        <Formik
          validationSchema={schema}
          initialValues={defaults}
          validateOnMount={true}
          onSubmit={({ password }) => req({
            method: 'patch',
            url: '/api/core/pwd-resets',
            data: { password, key: resetKey },
          })}
        >
          <Form>
            <FormHttpAlert res={res} />
            <h2>{t[lg].title}</h2>
            <FormGroup
              name="password"
              type="password"
              label={t[lg].newPwd}
              placeholder={t[lg].newPwdPh}
              affirm
            />
            <FormGroup
              name="passwordConfirm"
              type="password"
              label={t[lg].confirmPwd}
              affirm
            />
            <div className="form-group text-right">
              <FormHttpBtn
                res={res}
                type="submit"
                className="btn-block btn-primary"
                icon={faSave}
              >
                {t[lg].resetPwd}
              </FormHttpBtn>
            </div>
          </Form>
        </Formik>
      )}
    </>
  );
};

export default FormPwdReset;
